import React from 'react';
import { MessageCircle, Plus, PhoneCall, StickyNote, CalendarClock, UserX, FileDown, Ban, IndianRupee } from 'lucide-react';
import { can } from '../../../core/permissions';
import { lostStatus, isDND, doNotShipStatus, refundGivenStatus } from '../logic/telesales';

const badgeStyle = {
    Active: 'bg-green-100 text-green-700', Dormant: 'bg-amber-100 text-amber-700',
    Lost: 'bg-red-100 text-red-700', 'VIP Lost': 'bg-purple-100 text-purple-700', 'Repeat Lost': 'bg-orange-100 text-orange-700',
};

const ActionBtn = ({ icon: Icon, label, onClick, tone = 'slate', disabled, title }) => {
    const tones = { slate: 'border-slate-200 text-slate-700 hover:bg-slate-50', green: 'border-green-200 text-green-700 hover:bg-green-50', purple: 'bg-purple-600 text-white border-purple-600 hover:bg-purple-700', red: 'border-red-200 text-red-600 hover:bg-red-50' };
    return (
        <button onClick={onClick} disabled={disabled} title={title} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-sm font-medium disabled:opacity-40 ${tones[tone]}`}>
            <Icon size={15} /> {label}
        </button>
    );
};

const CustomerActionBar = ({ customer, currentUser, on, dialing = false }) => {
    const role = currentUser?.role;
    const mobile = customer?.primaryMobile || customer?.mobile;
    const m10 = String(mobile || '').replace(/\D/g, '').slice(-10);
    const { badge } = lostStatus(customer);
    const dnd = isDND(customer);
    const dns = doNotShipStatus(customer);
    const refund = refundGivenStatus(customer);

    return (
        <div className="bg-white rounded-xl border border-slate-100 p-3 flex flex-wrap items-center gap-2">
            <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${badgeStyle[badge] || 'bg-slate-100 text-slate-600'}`}>{badge}</span>
            {dnd && <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-red-600 text-white">DND</span>}
            {dns.flagged && (
                <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-red-600 text-white flex items-center gap-1" title={dns.note || dns.reason}>
                    <Ban size={11} /> DO NOT SHIP · {dns.reason}
                </span>
            )}
            {refund.flagged && (
                <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-cyan-100 text-cyan-700 flex items-center gap-1" title={`Refund issued${refund.amount ? ` ₹${refund.amount}` : ''}${refund.ref ? ` · ref ${refund.ref}` : ''}`}>
                    <IndianRupee size={11} /> Refund Given
                </span>
            )}
            {customer?.testimonialCandidate && <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-emerald-100 text-emerald-700">Testimonial</span>}
            <div className="w-px h-5 bg-slate-200 mx-1" />

            {can(role, 'canCallCustomer') && (
                <ActionBtn icon={PhoneCall} label={dialing ? 'Dialing…' : 'Call Customer'} tone="purple" onClick={on.call} disabled={dialing}
                    title={dnd ? 'This customer is marked Do Not Disturb' : 'Rings this customer on your phone'} />
            )}
            {mobile && <a target="_blank" rel="noreferrer" href={`https://wa.me/91${m10}`} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-emerald-200 text-emerald-700 hover:bg-emerald-50 text-sm font-medium"><MessageCircle size={15} /> WhatsApp</a>}
            {can(role, 'canAddOrderFromProfile') && <ActionBtn icon={Plus} label="Add Order" tone="green" onClick={on.addOrder} />}
            {can(role, 'canAddFeedback') && <ActionBtn icon={StickyNote} label="Feedback Call" onClick={on.feedback} />}
            {can(role, 'canAddRemark') && <ActionBtn icon={StickyNote} label="Add Remark" onClick={on.remark} />}
            {can(role, 'canCreateFollowUp') && <ActionBtn icon={CalendarClock} label="Create Follow-up" onClick={on.followUp} />}
            {can(role, 'canCallCustomer') && <ActionBtn icon={UserX} label={dnd ? 'Remove DND' : 'Mark DND'} tone="red" onClick={on.toggleDnd} />}
            <ActionBtn icon={Ban} label={dns.flagged ? 'Do Not Ship ✓' : 'Do Not Ship'} tone="red" onClick={on.doNotShip} />
            {can(role, 'canExportCustomers') && <ActionBtn icon={FileDown} label="Export" onClick={on.export} />}
        </div>
    );
};

export default CustomerActionBar;
